import { useBackend } from "../../services";
import { AlbumIdentifierType } from "./interfaces";

export const useModifyAlbumIdentifier = () => {
  const { put } = useBackend();
  const modifyAlbumIdentifier = (parameters: IModifyAlbumIdentifierParameters) =>
    put("albumIdentifiers", parameters);
  return { modifyAlbumIdentifier };
};

export interface IModifyAlbumIdentifierParameters {
  uuid: string;
  albumId: string;
  labelId?: string;
  codeParts: string[];
  description?: string;
  order: number;
  type: AlbumIdentifierType;
}
